import { SegHeaderLogo } from "../../Components/SegUI/SegHeaderLogo/SegHeaderLogo";
import { AvisosEmbudo } from "../../Components/Slides/Auto/Emision/AvisosEmbudo";
import segurarse from "../../Assets/img/logo_segurarse.svg";
import afip from "../../Assets/img/DATAWEB.jpg";
import "@splidejs/react-splide/css";
import { imagesCompanias } from "../../Assets/imageCompania";
import { SegSvg } from "../../Components/SegUI/SegSvg/SegSvg";
import { useEffect, useMemo, useRef, useState } from "react";
import { ModalPrecios } from "../../Components/Slides/Auto/Precios/ModalPrecios";
import { useNavigate, useParams } from "react-router-dom";
import { useCotizacionStore } from "../../Services/Providers/CotizacionStore";
import cotizar from "../../Services/API/Cotizar";
import { Slider } from "../../Components/Slides/Auto/Precios/Slider";
import { Grilla } from "../../Components/Slides/Auto/Precios/Grilla";
import guardarContacto from "../../Services/API/GuardarContacto";
import { SegLoading } from "../../Components/SegUI/SegLoading/SegLoading";
import { Cards } from "../../Components/Slides/Auto/Precios/Cards";
import { GraciasAuto } from "../Gracias/GraciasAuto";
import axios from "axios";
import { useDescripcionesStore } from "../../Services/Providers/DescripcionesStore";
import { useEmisionStore } from "../../Services/Providers/EmisionStore";
import useSEOConfig from "../../hooks/seo/useSEOConfig";
import { useConfiguracionEmpresa } from "../../Services/Providers/useConfiguracionEmpresa";
import { useConfig } from "../../context/ConfigContext";
import { getInicioCotizacion, getPasoDatos } from "../../utils/getRubro";
import { autoViaBffDesdeConfig } from "../../Services/API/bff/auto/flag";
import { crearContacto } from "../../Services/API/bff/auto/funnel";
import {
    escucharPrecios,
    cargarSnapshotPrecios,
    ContextoPrecios,
} from "../../Services/API/bff/auto/preciosBff";
import { aBffError } from "../../Services/API/bff/auto/bffError";
import { descripcionesDeCobertura } from "../../Services/API/bff/auto/adapters";
import {
    mensajeDeError,
    requiereVolverADatos,
} from "../../Services/API/bff/auto/errorMessages";
import { armarDescResumen } from "./armarDescResumen";

export interface Cotizacion {
    PrecioSinDescuento: string;
    DescuentoPorcentaje: number;
    id: null | string;
    nroCotizacion: string;
    codigoCobertura: string;
    descripcionCobertura: string;
    descripcionCoberturaOriginal: string;
    descripciones: Descripcion[];
    nombreCobertura: string;
    prima: number;
    columna: string;
    franquicia: string;
    premio: string;
    Parametros: string;
    SumaAsegurada: string;
    DescResumen: string[];
    LogoCompania: string;
    NombreCompania: string;
    CodigoCompania?:string;
    Mostrar: boolean;
    Afip: string;
    EmisionHabilitada: boolean;
}

interface Descripcion {
    Nombre: string;
    Descripcion: string;
    Aclaracion: null | string;
}

export interface CotizacionDesc {
    id: string;
    planName: string;
    discountAmount: string;
    discountPerc: string;
    amountMonth: string;
    descList: any[];
    companyLogo: string;
    companyName: string;
    codCompany?:string;
    fiscalInfoImg: string;
    sumaAsegurada: string;
}

export const Precios = () => {
    const { emisionValues, setEmisionValues } = useEmisionStore();
    const { config, origen } = useConfiguracionEmpresa();
    const {
        cotizacionValues,
        setCotizacionValues,
        vaciarCotizaciones,
    } = useCotizacionStore();
    const { descripcionesValues } = useDescripcionesStore();
    const [cotizando, setCotizando] = useState<boolean>(false);
    const [cargando, setCargando] = useState<boolean>(false);
    const { compania } = useParams();
    const nav = useNavigate();
    const {config: envConf} = useConfig()

    const [isCollapsed, setCollapsed] = useState(true);

    /** Camino nuevo: precios por una sola conexión SSE contra el BFF. */
    const viaBff = autoViaBffDesdeConfig(envConf);
    const conexionSse = useRef<{ cancelar: () => void } | null>(null);

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const handleScroll = () => {
        // Aquí puedes añadir lógica para determinar si el componente está abierto
        // y luego colapsarlo si es necesario
        if (!isCollapsed) {
            // Lógica para colapsar el componente
            setCollapsed(true);
        }
    };

    const handleSetCotizacionDesc = (cotizacion: CotizacionDesc) => {
        setEmisionValues({
            ...emisionValues,
            cotizacionDesc: cotizacion,
        });
    };

    useSEOConfig({
        title: "Moto",
        marcaBlanca: (config.origen !== "" && config.origen !== "SEGURARSE") ? config.origen.charAt(0).toUpperCase() +
            config.origen.slice(1).toLowerCase() : undefined
    })

    useEffect(() => {
        // Añade el event listener al objeto window
        window.addEventListener("scroll", handleScroll);
        // Limpia el event listener al desmontar el componente
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [isCollapsed]);

    const toggleCollapse = () => {
        // Invierte el estado de colapsado al hacer clic en el enlace
        setCollapsed(!isCollapsed);
    };

    const ajustarDescripciones = async (coti: any) => {
        try {
            let descripciones: Descripcion[] = [];
            const descripcionesGuardadas = descripcionesValues;
            (Object.keys(
                descripcionesGuardadas
            ) as (keyof typeof descripcionesGuardadas)[]).forEach((key, index) => {
                const desc = descripcionesGuardadas[index];
                if (
                    //desc.CompaniaDescripcion.replace(/\s+/g, '').toLowerCase() === coti.NombreCompania.replace(/\s+/g, '').toLowerCase() &&
                    desc.CompaniaDescripcion === coti.NombreCompania &&
                    desc.CodigoCompania === coti.codigoCobertura
                ) {
                    let texto;
                    if (desc.Texto === "si") {
                        texto = "Si";
                    } else if (desc.Texto === "no") {
                        texto = "No";
                    } else {
                        texto = desc.Texto;
                    }
                    let nuevaDesc: Descripcion = {
                        Nombre: desc.ItemDescripcion2Nombre,
                        Aclaracion: desc.Aclaraciones,
                        Descripcion: texto,
                    };
                    descripciones.push(nuevaDesc);
                }
            });
            return descripciones;
        } catch (error) { }
    };

    const descripcionesResumen = (descripciones: any[]) => armarDescResumen(descripciones);

    const descripcionCobertura = (columna: string) => {
        switch (columna) {
            case "A":
                return "Responsabilidad Civil";
            case "B":
                return "Terceros Completo";
            case "C":
                return "Terceros Completo Full";
            case "D":
            case "E":
                return "Todo Riesgo";
            default:
                return "";
        }
    };

    const cotizarInterno = async (compania: any, indexCompania: number) => {
        let nuevoArray: Cotizacion[] = [];
        try {
            const response: any = await cotizar(
                compania.codigoCompania,
                cotizacionValues.contactoId!,
                compania.emisionOnlineHabilitada,
                cotizacionValues.token!,
                source
            );
            if (response.data.api_status) {
                if (
                    response.data.api_status === 200 &&
                    response.data.api_data !== null
                ) {
                    if (response.data.api_data.items.length > 0) {
                        for (
                            let index = 0;
                            index < response.data.api_data.items.length;
                            index++
                        ) {
                            let cotiNueva = response.data.api_data.items[index];
                            let auxPrecio: number = Number.parseInt(cotiNueva.premio);
                            let auxSuma: number = cotiNueva.SumaAsegurada
                                ? Number.parseInt(cotiNueva.SumaAsegurada.toString())
                                : Number.parseInt(
                                    response.data.api_data.sumaAsegurada.toString()
                                );
                            cotiNueva.DescuentoPorcentaje = 30;
                            cotiNueva.PrecioSinDescuento = (auxPrecio * 1.2).toLocaleString(
                                "es-AR"
                            );
                            cotiNueva.LogoCompania = encontrarRuta(compania.codigoCompania);
                            cotiNueva.NombreCompania = compania.nombreCompania;
                            cotiNueva.CodigoCompania = compania.codigoCompania;
                            cotiNueva.Mostrar = true;
                            cotiNueva.Afip = afip;
                            cotiNueva.premio = auxPrecio.toLocaleString("es-AR");
                            cotiNueva.SumaAsegurada = auxSuma
                                ? auxSuma.toLocaleString("es-AR")
                                : "";
                            cotiNueva.nombreCobertura = descripcionCobertura(
                                cotiNueva.columna
                            );
                            cotiNueva.descripciones = await ajustarDescripciones(cotiNueva);
                            cotiNueva.DescResumen = descripcionesResumen(
                                cotiNueva.descripciones
                            );
                            cotiNueva.columna =
                                cotiNueva.columna === "E" ? "D" : cotiNueva.columna;
                            cotiNueva.EmisionHabilitada = compania.emisionOnlineHabilitada;
                            if (cotiNueva.descripciones.length > 0) {
                                nuevoArray.push(cotiNueva);
                            }
                            if (index === response.data.api_data.items.length - 1) {
                                if (nuevoArray.length > 0) {
                                    return nuevoArray;
                                } else {
                                    return [];
                                }
                            }
                        }
                    }
                }
                return [];
            }
        } catch (error) { }
        return [];
    };

    const ramoBff = "moto" as const;

    /** Contexto que el adaptador de precios necesita de esta pantalla. */
    const contextoPrecios = (): ContextoPrecios => ({
        companias: cotizacionValues.parametrosIniciales?.companias || [],
        logoDe: (codigo) => encontrarRuta(codigo || ""),
        afip,
        descripcionesDe: (codigoCobertura: string, codigoCompania: string) => {
            const guardadas: any = descripcionesValues || [];
            return descripcionesDeCobertura(
                Object.values(guardadas) as any[],
                codigoCobertura,
                codigoCompania
            ).map((desc) => ({
                Nombre: desc.ItemDescripcion2Nombre,
                Descripcion:
                    desc.Texto === "si"
                        ? "Si"
                        : desc.Texto === "no"
                        ? "No"
                        : desc.Texto,
                Aclaracion: desc.Aclaraciones ?? null,
            }));
        },
        resumenDe: (descripciones) => descripcionesResumen(descripciones) || [],
        sumaAseguradaFallback: cotizacionValues.sumaAseguradaIA
            ? Number(cotizacionValues.sumaAseguradaIA)
            : null,
    });

    const volverADatos = (mensaje: string) => {
        nav(`${getPasoDatos("moto", compania)}?error=${encodeURIComponent(mensaje)}`);
    };

    const crearContactoBff = async () => {
        try {
            await crearContacto(ramoBff, cotizacionValues);
        } catch (error) {
            const bffError = aBffError(error);
            if (bffError.code === "blocked") {
                const props = {
                    nombre: cotizacionValues.nombre + " " + cotizacionValues.apellido,
                    email: cotizacionValues.email!,
                    telefono:
                        cotizacionValues.telefono?.prefijo +
                        "" +
                        cotizacionValues.telefono?.numero,
                    vehiculo:
                        cotizacionValues.marca?.value +
                        " " +
                        cotizacionValues.version?.value +
                        " " +
                        cotizacionValues.año?.value,
                    aseguradora: "Sin seleccionar",
                    tipo: "emision",
                };
                return compania
                    ? nav("/moto/gracias-alt/" + compania, { state: props })
                    : nav("/moto/gracias-alt", { state: props });
            }
            return volverADatos(mensajeDeError(bffError));
        }
    };

    const dispararCotizacionSse = () => {
        setCotizando(true);
        const fechaConsultaCotizaciones = new Date();
        let acumuladas: Cotizacion[] = [];
        const ctx = contextoPrecios();

        const volcar = (items: any[]) => {
            acumuladas = acumuladas.concat(items as Cotizacion[]);
            setCotizacionValues({
                ...useCotizacionStore.getState().cotizacionValues,
                fechaConsultaCotizaciones,
                cotizaciones: acumuladas,
            });
        };

        conexionSse.current = escucharPrecios(ramoBff, ctx, {
            onInicio: ({ sumaAsegurada, vigenciaHasta }) => {
                // La suma de la cotización llega con `started`: alimenta el
                // fallback de los planes que no traen la suya.
                if (sumaAsegurada) ctx.sumaAseguradaFallback = sumaAsegurada;
                if (vigenciaHasta) {
                    setCotizacionValues({
                        ...useCotizacionStore.getState().cotizacionValues,
                        vigenciaHasta,
                    });
                }
            },
            onCompania: (_codigo, items) => volcar(items),
            onCompaniaError: (codigo, code) => {
                // eslint-disable-next-line no-console
                console.warn(`[auto_via_bff] ${codigo} no cotizó: ${code}`);
            },
            onFin: () => setCotizando(false),
            onFalla: async (error) => {
                if (requiereVolverADatos(error)) {
                    setCotizando(false);
                    return volverADatos(mensajeDeError(error));
                }
                try {
                    const items = await cargarSnapshotPrecios(ramoBff, ctx);
                    if (items.length) volcar(items as any[]);
                } catch (errorSnapshot) {
                    // eslint-disable-next-line no-console
                    console.warn(
                        "[auto_via_bff] snapshot de precios:",
                        aBffError(errorSnapshot).code
                    );
                }
                setCotizando(false);
            },
        });
    };

    useEffect(() => {
        vaciarCotizaciones();
        //cotizacionValues.cotizaciones = [];
        if (cotizacionValues.parametrosIniciales) {
            if (!esVigenciaCotizacionesValida()) {
                setTimeout(() => {
                    setCargando(false);
                }, 10000);
                setCargando(true);
            }
            if (!cotizacionValues?.contactoId) {
                if (viaBff) {
                    crearContactoBff();
                    return;
                }
                const fetchData = async () => {
                    const response: any = await guardarContacto(
                        //cotizacionValues?.parametrosIniciales.rubro,
                        "moto",
                        cotizacionValues?.parametrosIniciales.origen,
                        cotizacionValues?.parametrosIniciales.tipoCotizador,
                        cotizacionValues?.landingUrl,
                        cotizacionValues?.referer,
                        cotizacionValues?.patente,
                        cotizacionValues?.marca?.value,
                        cotizacionValues?.modelo?.value,
                        cotizacionValues?.version?.value,
                        cotizacionValues?.año?.value,
                        cotizacionValues?.email,
                        cotizacionValues?.telefono?.prefijo,
                        cotizacionValues?.telefono?.numero,
                        cotizacionValues?.fechaNac?.dia +
                        "/" +
                        cotizacionValues?.fechaNac?.mes +
                        "/" +
                        cotizacionValues?.fechaNac?.año,
                        cotizacionValues?.genero?.value === "M" ? "Masculino" : "Femenino",
                        cotizacionValues?.provincia?.value,
                        cotizacionValues?.localidad?.value,
                        cotizacionValues?.nombre,
                        cotizacionValues?.apellido,
                        cotizacionValues?.cuandoContrata?.label,
                        cotizacionValues?.captchaToken
                    );
                    if (response.data) {
                        if (
                            response.data.api_status === 200 &&
                            response.data.api_data !== null
                        ) {
                            setCotizacionValues({
                                ...cotizacionValues,
                                contactoId: response.data.api_data.idContacto,
                                sumaAseguradaIA: response.data.api_data.sumaAseguradaIA,
                                token: response.data.api_data.token,
                            });
                        } else if (
                            response.data.api_data ===
                            "El Mail informado no es un mail válido"
                        ) {
                            compania
                                ? nav(
                                    "/moto/cotizacion/" +
                                    compania +
                                    "/email?error=Por favor, ingresá una dirección de correo electrónico válida"
                                )
                                : nav(
                                    "/moto/cotizacion/email?error=Por favor, ingresá una dirección de correo electrónico válida"
                                );
                        } else if (response.data.api_data === "El Captcha no es válido") {
                            compania
                                ? nav(
                                    "/moto/cotizacion/" +
                                    compania +
                                    "/codigo-postal?error=El Captcha no es válido"
                                )
                                : nav(
                                    "/moto/cotizacion/codigo-postal?error=El Captcha no es válido"
                                );
                        } else if (response.data.api_data === "Origen Inválido") {
                            nav(getInicioCotizacion("moto", compania) + "?error=Orígen inválido");
                        } else if (
                            response.data.api_data === "El Teléfono informado no es válido"
                        ) {
                            compania
                                ? nav(
                                    "/moto/cotizacion/" +
                                    compania +
                                    "/telefono?error=Por favor, ingresá un n° de teléfono válido"
                                )
                                : nav(
                                    "/moto/cotizacion/telefono?error=Por favor, ingresá un n° de teléfono válido"
                                );
                        } else if (
                            response.data.api_data === "La localidad no es válida."
                        ) {
                            compania
                                ? nav(
                                    "/moto/cotizacion/" +
                                    compania +
                                    "/codigo-postal?error=Por favor, ingresá nuevamente la localidad"
                                )
                                : nav(
                                    "/moto/cotizacion/codigo-postal?error=Por favor, ingresá nuevamente la localidad"
                                );
                        } else if (
                            response.data.api_data.startsWith(
                                "*** Se recibió cotización BLOQUEADA"
                            )
                        ) {
                            var props = {
                                nombre:
                                    cotizacionValues.nombre + " " + cotizacionValues.apellido,
                                email: cotizacionValues.email!,
                                telefono:
                                    cotizacionValues.telefono?.prefijo +
                                    "" +
                                    cotizacionValues.telefono?.numero,
                                vehiculo:
                                    cotizacionValues.marca?.value +
                                    " " +
                                    cotizacionValues.version?.value +
                                    " " +
                                    cotizacionValues.año?.value,
                                aseguradora: "Sin seleccionar",
                                tipo: "emision",
                            };
                            compania
                                ? nav("/moto/gracias-alt/" + compania, { state: props })
                                : nav("/moto/gracias-alt", { state: props });
                        } else {
                            nav("/moto/error");
                        }
                    } else {
                        compania
                            ? nav(
                                "/moto/cotizacion/" +
                                compania +
                                "/codigo-postal?error=Error de conexion."
                            )
                            : nav(
                                "/moto/cotizacion/codigo-postal?error=Error de conexion."
                            );
                    }
                };
                fetchData();
            }
        } else {
            nav(getInicioCotizacion("moto", compania));
        }
    }, []);

    useEffect(() => {
        if (cotizacionValues.contactoId) {
            dispararCotizacion();
        }
        return () => {
            source.cancel();
            conexionSse.current?.cancelar();
        };
    }, [cotizacionValues.contactoId]);

    const esVigenciaCotizacionesValida = (): boolean => {
        if (
            cotizacionValues.cotizaciones &&
            cotizacionValues.cotizaciones.length > 0
        ) {
            // Camino BFF: la vigencia la fija el backend, no el "mismo día".
            if (cotizacionValues.vigenciaHasta) {
                const vence = Date.parse(cotizacionValues.vigenciaHasta);
                if (!Number.isNaN(vence)) return vence > Date.now();
            }
            const fechaEnSesion = new Date(
                cotizacionValues.fechaConsultaCotizaciones + ""
            );
            const fechaActual = new Date();
            if (
                fechaActual.getFullYear() !== fechaEnSesion?.getFullYear() ||
                fechaActual.getMonth() !== fechaEnSesion.getMonth() ||
                fechaActual.getDate() !== fechaEnSesion.getDate()
            ) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    };

    const dispararCotizacion = async () => {
        if (esVigenciaCotizacionesValida()) return;

        if (viaBff) {
            dispararCotizacionSse();
            return;
        }

        setCotizando(true);
        let nuevasCotis: Cotizacion[] = [];
        try {
            const fechaConsultaCotizaciones = new Date();
            await Promise.all(
                cotizacionValues.parametrosIniciales.companias.map(
                    async (compania: any, index: number, array: []) => {
                        const results = await cotizarInterno(compania, index);
                        if (results && results.length > 0) {
                            nuevasCotis = nuevasCotis.concat(results);
                            setCotizacionValues({
                                ...cotizacionValues,
                                fechaConsultaCotizaciones,
                                cotizaciones: nuevasCotis,
                            });
                        }
                    }
                )
            );
        } catch (error) {
            setCotizacionValues({
                ...cotizacionValues,
                cotizaciones: [],
            });
        } finally {
            setCotizando(false);
        }
    };

    /*const fetchCotis = async (compania: any, index: number) => {
          return await cotizarInterno(compania, index);
      }*/

    const encontrarRuta = (compania: string) => {
        if (compania) {
            let find = imagesCompanias.find(
                (comp) =>
                    comp.nombreCompania.toLocaleLowerCase() ===
                    compania.toLocaleLowerCase()
            );
            if (find) {
                return find.imgRuta;
            } else {
                return "";
            }
        } else {
            return "";
        }
    };

    const irAInicio = (event: any) => {
        event.preventDefault();
        setCotizacionValues({
            ...cotizacionValues,
            contactoId: undefined,
        });
        nav(getInicioCotizacion("moto", compania));
    };

    const segLoadingComponent = useMemo(
        () => (
            <SegLoading
                loadingTitle="Cargando"
                icon="#ico-moto"
                product={
                    cotizacionValues?.marca?.label +
                    " " +
                    cotizacionValues?.version?.label
                }
                captions={[
                    {
                        value: "Gratuito",
                    },
                    {
                        value: "Online",
                    },
                    {
                        value: "Personalizado",
                    },
                ]}
                backgroundColor={origen !== "SEGURARSE" ? config.colors.primary : undefined}
                productTextColor={origen !== "SEGURARSE" ? config.colors.tertiary : undefined}
                dotsColors={origen !== "SEGURARSE" ? [config.colors.secondary, config.colors.tertiary, config.colors.accent] : undefined}
            />
        ),
        [cotizacionValues?.marca?.label, cotizacionValues?.version?.label]
    );
    return (
        <>
            <ModalPrecios cotizacionDesc={{ ...emisionValues.cotizacionDesc! }} rubro="Moto"/>
            <AvisosEmbudo className="maxw-1170p mx-auto mt-3" />
            {cargando ? (
                segLoadingComponent
            ) : cotizacionValues.año?.value !== "0 Km" &&
                new Date().getFullYear() - parseInt(cotizacionValues.año?.value!) >=
                parseInt(envConf.anio_gracias! + "") ? (
                <GraciasAuto
                    nombre={cotizacionValues.nombre + " " + cotizacionValues.apellido}
                    email={cotizacionValues.email!}
                    telefono={
                        cotizacionValues.telefono?.prefijo +
                        "" +
                        cotizacionValues.telefono?.numero
                    }
                    vehiculo={
                        cotizacionValues.marca?.value +
                        " " +
                        cotizacionValues.version?.value +
                        " " +
                        cotizacionValues.año?.value
                    }
                    tipo="vehiculoantiguo"
                />
            ) : (
                <div>
                    <SegSvg />
                    <header className="site-header sticky-lg-top" 
                    style={{ background: origen !== "SEGURARSE" ? config.colors.navbar : "#ffffff" }}>
                        <div className="container">
                            {
                                origen !== "SEGURARSE" ?
                                    <div className="row">
                                        <div className="col-md-6 offset-md-3 text-center d-flex justify-content-center gap-3">
                                            {" "}
                                            {/* Centra el contenido en la columna */}
                                            <SegHeaderLogo
                                                img={config.images.logo}
                                                alt="Logo Segurarse"
                                                width={window.innerWidth > 768 ? "130px" : "100px"}
                                                style={{ filter: "brightness(0) invert(1)" }}
                                            />
                                            <div style={{ height: "100%", width: "2px", backgroundColor: "#ffffff" }}></div>
                                            <SegHeaderLogo
                                                img={segurarse}
                                                alt="Logo Segurarse"
                                                width={window.innerWidth > 768 ? "140px" : "110px"}
                                                style={{ filter: "brightness(0) invert(1)" }}
                                            />
                                        </div>
                                    </div>
                                    :
                                    <div className="row">
                                        <div className="col-md-6 offset-md-3 text-center">
                                            {" "}
                                            {/* Centra el contenido en la columna */}
                                            <SegHeaderLogo
                                                img={segurarse}
                                                alt="Logo Segurarse"
                                                width="160px"
                                            />
                                        </div>
                                    </div>
                            }

                        </div>
                    </header>
                    <main className="sec-precios">
                        <div className="main-wrapper">
                            <div className="ac-desktop" style={origen !== "SEGURARSE" ? { background: config.colors.accent } : {}}>
                                <div>
                                    <b>{"Moto cotizada > "}</b>
                                    <b>
                                        {cotizacionValues.marca?.value +
                                            " " +
                                            cotizacionValues.version?.value +
                                            " " +
                                            cotizacionValues.año?.value}{" "}
                                        |
                                    </b>{" "}
                                    Zona de guardado: <b>{cotizacionValues.localidad?.label}</b>{" "}
                                </div>
                                <div>
                                    <a
                                        href="/#"
                                        onClick={(e) => irAInicio(e)}
                                        className="btn1 btn1-light"
                                    >
                                        Modificar datos
                                    </a>
                                </div>
                            </div>

                            <div className="ac-mobile d-lg-none">
                                <div className="wrapper">
                                    <a
                                        className={`trigger ${isCollapsed ? "collapsed" : ""}`}
                                        data-bs-toggle="collapse"
                                        href="#collapseExample"
                                        aria-controls="collapseExample"
                                        role="button"
                                        aria-expanded="false"
                                        onClick={toggleCollapse}
                                        style={origen !== "SEGURARSE" ? { background: config.colors.accent } : {}}
                                    >
                                        <svg className="icon ico-car">
                                            <use xlinkHref="#ico-moto" />
                                        </svg>{" "}
                                        cotizada
                                        <svg className="icon ico-arrow">
                                            <use xlinkHref="#arrowright2" />
                                        </svg>
                                    </a>
                                    <div
                                        className={`collapse ${isCollapsed ? "" : "show"}`}
                                        id="collapseExample"
                                    >
                                        <div className="detail"
                                            style={origen !== "SEGURARSE" ? { background: config.colors.accent } : {}}
                                        >
                                            <p>
                                                <b>
                                                    {cotizacionValues.marca?.value +
                                                        " " +
                                                        cotizacionValues.version?.value +
                                                        " " +
                                                        cotizacionValues.año?.value}
                                                </b>
                                                <br />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ban" 
                            style={origen !== "SEGURARSE" ? { background: config.colors.primary } : {}}>
                                <div>
                                    <div>
                                        <svg className="icon">
                                            <use xlinkHref="#moneyrecive" />
                                        </svg>
                                    </div>
                                    <div>
                                        <b>Descuento online contratando ahora. </b>
                                        <br className="d-md-none" />
                                        Válido con <b>tarjeta de crédito (no prepaga)</b>
                                    </div>
                                </div>
                                {cotizando && (
                                    <div className="clearfix">
                                        <div className="spinner-border spinner-border-sm float-end"></div>
                                        <span style={{ marginRight: "5px" }} role="status">
                                            Seguimos cotizando...
                                        </span>
                                    </div>
                                )}
                            </div>
                            {window.innerWidth > 768 && (
                                <>
                                    <Slider
                                        pais="AR"
                                        cotizando={cotizando}
                                        cotizaciones={cotizacionValues.cotizaciones || []}
                                        setDescripciones={handleSetCotizacionDesc}
                                        rubro="Moto"
                                    />
                                    <Grilla
                                        cotizando={cotizando}
                                        cotizaciones={cotizacionValues.cotizaciones || []}
                                        setDescripciones={handleSetCotizacionDesc}
                                        rubro="Moto"
                                    />
                                </>
                            )}
                            <Cards
                                cotizando={cotizando}
                                cotizaciones={cotizacionValues.cotizaciones || []}
                                setDescripciones={handleSetCotizacionDesc}
                                rubro="Moto"
                            />
                        </div>
                    </main>
                </div>
            )}
        </>
    );
};
